import {productService} from '@/assets/js/http'

/**
 * 投票详情
 */
 export function voteDetailAPI(id) {
    return productService({
        url:`api/haiyan/vote/votedetail/${id}`,
        method: 'get'
    })
}

// 投票
export function voteSubmitAPI(data) {
    return productService({
        url: 'api/haiyan/vote/voteaction',
        method: 'post',
        data
    })
}

/**
 * 投票记录详情
 */
 export function voteRecordDetailAPI(id) {
    return productService({
        url:`api/haiyan/vote/voteresult/${id}`,
        method: 'get'
    })
}